const clickoutside = {
  bind(el, binding) {
    const documentHandler = (e) => {
      if (el.contains(e.target)) return;
      if (binding.value) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener("click", documentHandler);
  },
  unbind(el) {
    document.removeEventListener("click", el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
};

export default clickoutside;


// WEBPACK FOOTER //
// ./src/clickoutside/index.js